import Sentry from "@similarweb/sentry-logger";

import type {
    ActionableInsights,
    ActionableInsightsParams,
    ActivationMetadata,
    PriorityAlerts,
    ShareOfVoiceWidgetResponse,
    TrafficWidgetResponse,
} from "app/pages/activation/types/api";
import type { IFetchService } from "app/services/fetchService";

import { ACTIVATION_API, ACTIVATION_HOME_API } from "../constants";

export const homeWithData = (fetchService: IFetchService) => ({
    getShareOfVoice: async (activationId: string): Promise<ShareOfVoiceWidgetResponse | null> => {
        try {
            return await fetchService.get(`${ACTIVATION_HOME_API}/${activationId}/share-of-voice`);
        } catch (error) {
            Sentry.errorTracker({
                message: "activationApiService: Error fetching Share of voice for widget in Homepage with data",
                e: error,
                level: "error",
            });
            throw new Error("Failed to fetch Share of voice object");
        }
    },
    getTraffic: async (activationId: string): Promise<TrafficWidgetResponse | null> => {
        try {
            return await fetchService.get(`${ACTIVATION_HOME_API}/${activationId}/traffic`);
        } catch (error) {
            Sentry.errorTracker({
                message: "activationApiService: Error fetching Traffic for widget in Homepage with data",
                e: error,
                level: "error",
            });
            throw new Error("Failed to fetch Traffic object");
        }
    },
    getActivationMetadata: async (): Promise<ActivationMetadata> => {
        try {
            return await fetchService.get(`${ACTIVATION_HOME_API}/activations-metadata`);
        } catch (error) {
            Sentry.errorTracker({
                message: "activationApiService: Error fetching activation metadata",
                e: error,
                level: "error",
            });
            throw new Error("Failed to fetch activation metadata");
        }
    },
    getPriorityAlerts: async (activationId: string): Promise<PriorityAlerts> => {
        try {
            return await fetchService.get(`${ACTIVATION_HOME_API}/${activationId}/priority-alerts`);
        } catch (error) {
            Sentry.errorTracker({
                message: "activationApiService: Error fetching priority alerts",
                e: error,
                level: "error",
            });
        }
    },
    getActionableInsights: async (params: ActionableInsightsParams): Promise<ActionableInsights> => {
        try {
            return await fetchService.get(`${ACTIVATION_API}/actionableInsights`, params);
        } catch (error) {
            Sentry.errorTracker({
                message: "activationApiService: Error fetching actionable insights",
                e: error,
                level: "error",
            });
            throw new Error("Failed to fetch actionable insights");
        }
    },
});
